import RelationshipMetadata from "../../RelationshipMetadata";

class ProjectPlanPhaseProjectPlanPhaseReferenceRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseProjectPlanPhaseReferenceRelationshipMetadata";
        this.parentEnterpriseComponent = "ProjectPlanPhase";
        this.childEnterpriseComponent = "ProjectPlanPhaseReference";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ProjectPlanPhaseUSID";
    }
}

export default ProjectPlanPhaseProjectPlanPhaseReferenceRelationshipMetadata;